import WordPressContent from "components/WordPressContent/WordPressContent";

const Terms = () => {
  return (
    <div id="main-content-target" className="terms-page">
      <WordPressContent
        slug="terms-of-use-healthcare-providers"
        title="Terms of Use for Healthcare Providers"
      />
    </div>
  );
}

export default Terms;
